/**
 * @fileoverview DELETE handler for the "/apps/business/accounts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsLegacyCatalogAccountsCacheKeys } from "./constants";
import type { DeleteLegacyCatalogAccountsProps, LegacyCatalogAccountsResult } from "./types";

export const deleteLegacyCatalogAccounts = reactQueryMutationAdapter(
  appsLegacyCatalogAccountsCacheKeys,
  (props: DeleteLegacyCatalogAccountsProps): Promise<LegacyCatalogAccountsResult> => {
    return fetch("/apps/business/accounts", "DELETE", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
